import { EstimationSteps, EvaluationSteps } from '~valuation/enums';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';

const getStepsCount = (valuationType: ValuationTypeEnum) => {
  const steps =
    valuationType === ValuationTypeEnum.PORTFOLIO
      ? EvaluationSteps
      : EstimationSteps;

  return Object.values(steps).filter((v) => typeof v === 'number').length;
};

export default getStepsCount;
